module.exports = "https://static.energy5.com/_next/static/images/largeDecor-c0c8e369aa024de8ba9aad223f71260b.png";